import { Injectable } from '@angular/core';

@Injectable()
export class Configuration {
  public apiServer: string;
  public defaultApiServer: string;
  public brandRequirementRestrictions: string;
}
